import { render, staticRenderFns } from "./FormContactanos.vue?vue&type=template&id=5441682c&scoped=true&"
import script from "./FormContactanos.vue?vue&type=script&lang=js&"
export * from "./FormContactanos.vue?vue&type=script&lang=js&"
import style0 from "./FormContactanos.vue?vue&type=style&index=0&id=5441682c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441682c",
  null
  
)

export default component.exports